export default "__VITE_ASSET__ShLFqVI8xue0ZXbFLAmM8g__ 480w, __VITE_ASSET__V47HoeQBgiUEQbXS1PpE9g__ 848w";